<template>
  <cv-content id="main-content" style="max-width: 1200px;" >
    <!--
    <cv-breadcrumb>
      <cv-breadcrumb-item>
        <cv-link href="#" aria-current="page">Ricerca Lavori</cv-link>
      </cv-breadcrumb-item>
    </cv-breadcrumb>
    -->
    <cv-grid>
      <cv-row>
        <cv-column :sm="4" :md="4" :lg="8">
          <data-valida etichetta="Dalla Data"
                       v-model="modello.dalla_data"
                       messaggio_non_valido="Data iniziale non valida"/>
        </cv-column>
        <cv-column :sm="4" :md="4" :lg="8">
          <data-valida etichetta="Alla Data"
                       v-model="modello.alla_data"
                       messaggio_non_valido="Data finale non valida"/>
        </cv-column>
      </cv-row>

      <cv-row>
        <cv-column :sm="4" :md="4" :lg="8">
          <cv-select label="Sulle Fatture" v-model="modello_fatture">
            <cv-select-option selected>Tutti</cv-select-option>
            <cv-select-option>Solo da fatturare</cv-select-option>
            <cv-select-option>Solo già fatturati</cv-select-option>
          </cv-select>
        </cv-column>
        <cv-column :sm="4" :md="4" :lg="8">
          <cv-select label="Su Incasso" v-model="modello_incasso">
            <cv-select-option selected>Tutti</cv-select-option>
            <cv-select-option>Solo da incassare</cv-select-option>
            <cv-select-option>Solo già incassati</cv-select-option>
          </cv-select>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="4" :lg="8">
          <cv-tile style="margin-top: 0.5em; margin-bottom: 0.5em;">
            <h6>Tipo di Stampa</h6>
            <cv-radio-group :vertical="true">
              <cv-radio-button name="tipostampa"
                               label="Lista"
                               value="1"
                               v-model="modello_tipo" />
              <cv-radio-button name="tipostampa"
                               label="Lista per Coltura"
                               value="2"
                               v-model="modello_tipo" />
            </cv-radio-group>
          </cv-tile>
        </cv-column>
        <cv-column :sm="4" :md="4" :lg="8">
          <cv-tile style="margin-top: 0.5em; margin-bottom: 0.5em;">
            <h6>Includere / Escludere</h6>
            <cv-checkbox label="Dettagli"
                         :value="v_dettagli"
                         :checked="flg_dettagli"/>
            <cv-checkbox label="Totale con Iva"
                         :value="v_totale_con_iva"
                         :checked="flg_totale_con_iva" />
            <cv-checkbox label="Dati Economici"
                         :value="v_dati_economici"
                         :checked="flg_dati_economici" />
          </cv-tile>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-combo-box label=""
                        title="Cliente" :auto-filter="true"
                        value=""
                        :options="clienti"></cv-combo-box>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-combo-box label=""
                        :auto-filter="true"
                        title="Coltura" value=""
                        :options="colture"></cv-combo-box>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-combo-box label=""
                        :auto-filter="true"
                        title="Fondo" value=""
                        :options="fondi"></cv-combo-box>
        </cv-column>
      </cv-row>
    </cv-grid>
    <hr/>
    <BottonieraRicerche v-on:filtra-premuto="$emit('bottone-premuto')"
                        v-on:pdf-premuto="$emit('bottone-premuto')" />
  </cv-content>
</template>

<script>
import BottonieraRicerche from "@/components/BottonieraRicerche";

export default {
  name: "RicercaLavori",
  components: { BottonieraRicerche },
  data: function() {
    return {
      modello: {
        dalla_data: "",
        alla_data: ""
      },

      modello_tipo: "1",
      v_dettagli: "0",
      flg_dettagli: false,
      v_totale_con_iva: "1",
      flg_totale_con_iva: true,
      v_dati_economici: "1",
      flg_dati_economici: true,
      modello_fatture: "Tutti",
      modello_incasso: "Tutti",

      clienti: [
          {
            value: "1",
            label: "Azienda Agricola Mario Rossi s.r.l",
            name: "Azienda Agricola Mario Rossi s.r.l"
          },
          {
            value: "2",
            label: "Paolo Verdi s.r.l",
            name: "Paolo Verdi s.r.l"
          }
      ],
      colture: [
        {
          value: "1",
          label: "Barbabietole",
          name: "Barbabietole"
        },
        {
          value: "2",
          label: "Grano",
          name: "Grano"
        }
      ],
      fondi: [
        {
          value: "1",
          label: "Fusignano",
          name: "Fusignano"
        },
        {
          value: "2",
          label: "Russi",
          name: "Russi"
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>